import { ThreeProgressiveDots } from "../loaders/loaders";

const LinkWithLoader = ({
  text,
  children,
  onClick,
  isLoading,
  disabled = false,
  className = "",
}) => (
  <a
    className={`${className} ${disabled ? "disabled" : ""}`}
    onClick={isLoading || disabled ? undefined : onClick}
  >
    {isLoading ? <ThreeProgressiveDots className="text-center" /> : text || children}
  </a>
);

export default LinkWithLoader;
